import register from "./index.vue";

(register as any).install = function (Vue: any) {
  Vue.component(register.name, register);
};

export default register;
